import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { useFeatureGate } from '@statsig/react-bindings';
import { useTranslations } from 'next-intl';

const HSAFSAContent = () => {
  const hsaFsaGate = useFeatureGate('hsafsa_rollout').value;
  const t = useTranslations();

  return (
    <>
      {hsaFsaGate ? (
        <Typography className="border-b border-sandstone-500/50 pb-5 text-base font-medium">
          {t('bundle_modal_subtext_hsa_fsa')}
        </Typography>
      ) : (
        <Typography className="border-b border-sandstone-500/50 pb-5 text-base font-medium">
          {t('bundle_modal_subtext')}
        </Typography>
      )}
    </>
  );
};

export default HSAFSAContent;
